/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=regular&m=free */
import { faArrowAltCircleDown, faBell, faCheckCircle, faCircle, faDotCircle, faFlag, faHandshake, } from '@fortawesome/free-regular-svg-icons';
export const fontAwesomeRegularIcons = {
    faArrowAltCircleDown,
    faBell,
    faCheckCircle,
    faCircle,
    faDotCircle,
    faFlag,
    faHandshake,
};
